<template>
  <aside class="w-full h-full flex flex-col border-r border-gray-100 dark:border-gray-700 bg-white dark:bg-[#1C2128] overflow-y-auto">
    <div class="p-3">
      <CalendarCreateButton @click="emit('create')" />
    </div>

    <CalendarMiniMonth
      :selected-date="selectedDate"
      @select="emit('date-select', $event)"
    />

    <div class="border-t border-gray-100 dark:border-gray-700 mt-1">
      <CalendarCalendarList
        :calendars="calendars"
        :visible-ids="visibleCalendarIds"
        :loading="loading"
        @toggle="emit('toggle-calendar', $event)"
      />
    </div>

    <div class="border-t border-gray-100 dark:border-gray-700 mt-1 px-2 py-2">
      <p class="px-2 mb-1 text-[10px] font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">Tasks</p>
      <button
        class="w-full flex items-center gap-2.5 px-2 py-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-left"
        @click="calendarStore.toggleTasksVisibility()"
      >
        <CalendarCheckbox :checked="calendarStore.showTasksOnCalendar" color="#3b82f6" />
        <span class="text-sm text-gray-700 dark:text-gray-300 truncate flex-1 leading-none">Show tasks on calendar</span>
      </button>
    </div>
  </aside>
</template>

<script setup>
import { useCalendarStore } from 'stores/calendar.js'
import CalendarCreateButton   from './CalendarCreateButton.vue'
import CalendarMiniMonth      from './CalendarMiniMonth.vue'
import CalendarCalendarList   from './CalendarCalendarList.vue'
import CalendarCheckbox       from './CalendarCheckbox.vue'

defineProps({
  selectedDate:       { type: Date,    default: null  },
  calendars:          { type: Array,   required: true },
  visibleCalendarIds: { type: Array,   required: true },
  loading:            { type: Boolean, default: false  },
})

const emit = defineEmits(['create', 'date-select', 'toggle-calendar'])
const calendarStore = useCalendarStore()
</script>
